(() => {
  if (customElements.get('libero-insert-addon')) return;
  const dimensions = (value) => {
    const numbers = String(value || '').match(/\d+(?:\.\d+)?/g);
    return numbers?.length >= 2 ? numbers.slice(0, 2).map(Number).join('x') : '';
  };
  customElements.define('libero-insert-addon', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.controller = new AbortController();
      this.choice = this.querySelector('[data-insert-choice]');
      this.quantity = this.querySelector('[data-insert-quantity]');
      this.status = this.querySelector('[data-insert-status]');
      try { this.variants = JSON.parse(this.querySelector('[data-insert-variants]').textContent); } catch { this.variants = []; }
      this.size = this.dataset.coverSize;
      this.pending = false;
      this.choice.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      this.root.addEventListener('change', (event) => {
        if (!event.target.closest('variant-selects')) return;
        this.pending = true;
        this.update();
      }, { capture: true, signal: this.controller.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.root.dataset.section) return;
          this.size = data.variant?.options?.[Number(this.dataset.sizeIndex)] || '';
          this.pending = false;
          this.update();
        });
      }
      const selected = this.root.querySelector('variant-selects [data-selected-variant]');
      if (selected) {
        try { this.size = JSON.parse(selected.textContent)?.options?.[Number(this.dataset.sizeIndex)] || this.size; } catch {}
      }
      this.update();
      this.hidden = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.unsubscribe?.();
    }
    update() {
      const key = dimensions(this.size);
      this.variant = key ? this.variants.find(variant => dimensions(variant.size) === key) : null;
      const available = Boolean(this.variant?.available);
      if (!available && !this.pending) this.choice.checked = false;
      this.choice.disabled = !available || this.pending;
      this.dataset.selected = String(this.choice.checked);
      this.querySelector('[data-insert-size]').textContent = this.variant?.size || '';
      this.querySelector('[data-insert-price]').textContent = this.variant?.price || '';
      this.status.textContent = this.pending ? this.dataset.pending : !this.variant ? this.dataset.noMatch : !available ? this.dataset.soldOut : '';
      const selected = this.choice.checked && available && !this.pending;
      this.quantity.disabled = !selected;
      this.querySelector('[data-insert-quantity-row]').hidden = !selected;
      this.querySelector('[data-insert-hint]').hidden = !selected;
      if (this.variant) {
        this.quantity.min = this.variant.min;
        this.quantity.step = this.variant.step;
        this.quantity.max = Math.min(5, this.variant.max ?? 5);
        if (!this.quantity.checkValidity()) this.quantity.value = this.variant.min;
      }
    }
    getSelection() {
      if (!this.choice.checked) return null;
      if (this.pending) return { error: this.dataset.pending };
      if (!this.variant?.available) return { error: this.dataset.noMatch };
      if (!this.quantity.checkValidity() || !Number.isInteger(Number(this.quantity.value))) {
        this.quantity.reportValidity();
        return { error: this.dataset.quantityError };
      }
      return { id: String(this.variant.id), quantity: Number(this.quantity.value) };
    }
  });
})();
